export default {
  title: 'PROVIDER AVAILABILITY SETTINGS',
  items: {
    ProviderRequireAvailability : {
      label: 'Provider Require Availability',
      type: 'boolean'
    },
    ProviderAvailabilityNotifications : {
      label: 'Provider Availability Notifications',
      type: 'boolean'
    }
  }
}
  


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/provider-availability-settings.js